
  import { computed, defineComponent } from 'vue';
  import { Icon, Typography, Hint } from '@voximplant/spaceui';
  import Loading from '@/components/animation/Loading.vue';
  import { useStore } from 'effector-vue/composition.cjs';
  import {
    $callDuration,
    $calls,
    $currentSelectCallId,
    currentActiveCall,
    currentSelectCall,
  } from '@/store/calls';
  import { $settings } from '@/store/settings';
  import { timeFormat } from '@/lib/Helpers';
  import { useI18n } from 'vue-i18n';

  export default defineComponent({
    name: 'UserWithoutVideo',
    components: {
      Icon,
      Typography,
      Loading,
      Hint,
    },
    props: {
      isWindow: {
        type: Boolean,
        default: false,
      },
      showLoading: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const { t } = useI18n();
      const activeCall = useStore(currentActiveCall);
      const settingsState = useStore($settings);
      const allCalls = useStore($calls);
      const selectCall = useStore(currentSelectCall);
      const currentSelectCallId = useStore($currentSelectCallId);
      const callDuration = useStore($callDuration);
      const isRemoteMute = computed(() => allCalls.value[currentSelectCallId.value]?.params.muted);
      const blockClasses = computed(() => ({
        background: props.isWindow,
      }));
      const getColor = computed(() => {
        return props.isWindow || settingsState.value.maximize;
      });
      return {
        t,
        callDuration,
        isRemoteMute,
        activeCall,
        settingsState,
        timeFormat,
        blockClasses,
        getColor,
        selectCall,
      };
    },
  });
